/* -------------------------------------------- */
// PEOPLE GRID SLIDER
// Wait for load to set card height properly
// There should be solution a to achieve the same result without waiting for window load.

$("section.b-slideshow").each(function () {
  let $block = $(this);
  let $slider = $block.find(".slideshow");
  $slider.slick({
    infinite: false,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    centerMode: false,
    prevArrow: $block.find(".slick-arrows .prev-arrow"),
    nextArrow: $block.find(".slick-arrows .next-arrow"),
    appendDots: $block.find(".slick-dots-wrapper"),
  });
});



// WEBPACK FOOTER //
// ./scripts/components/slideshowSlider.js